import React from 'react';
import { Link } from 'react-router-dom';
import { Factory, Calendar, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { installationGallery } from '../../mock/mockData';

const ProjectsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Featured <span className="text-alden-green">Projects</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Successfully installed 100+ mineral water bottling plants across India with complete turnkey solutions.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {installationGallery.slice(0, 3).map(project => (
            <Card key={project.id} className="overflow-hidden hover:shadow-2xl transition-all group">
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={project.image} 
                  alt={project.client}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-alden-green text-white px-4 py-2 rounded-full font-bold text-sm">
                  {project.capacity}
                </div>
              </div>
              <CardContent className="p-6">
                <div className="flex items-center gap-2 text-alden-green font-semibold mb-2">
                  <Factory className="w-5 h-5" />
                  <span>{project.city}, {project.state}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{project.client}</h3>
                <p className="text-gray-600 text-sm mb-4">{project.description}</p>
                <div className="flex items-center gap-2 text-gray-500 text-sm">
                  <Calendar className="w-4 h-4" />
                  <span>{project.year}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/installation-gallery">
            <Button className="bg-alden-green hover:bg-alden-green-light text-white py-6 px-10 text-lg font-semibold">
              View All Projects
              <ArrowRight className="ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
